define(["exports", "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose", "styled-components", "../../themes"], function (_exports, _taggedTemplateLiteralLoose2, _styledComponents, _themes) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.DropdownBox = void 0;
  _taggedTemplateLiteralLoose2 = _interopRequireDefault(_taggedTemplateLiteralLoose2);
  _styledComponents = _interopRequireWildcard(_styledComponents);

  var _templateObject;

  var DropdownBox = _styledComponents.default.ul.withConfig({
    displayName: "DropdownBox",
    componentId: "sc-fmmqa7-0"
  })(["background-color:", ";height:0;list-style:none;margin:0;opacity:0;pointer-events:none;transform:translate3d(0,10px,0);visibility:hidden;width:100%;", " li:last-of-type{border-bottom:1px solid ", ";padding-bottom:24px;}", ";"], function (_ref) {
    var theme = _ref.theme;
    return theme.colors.white;
  }, function (_ref2) {
    var active = _ref2.active;
    return active && (0, _styledComponents.css)(["height:auto;opacity:1;padding:8px 16px 16px;pointer-events:auto;transform:translate3d(0,0,0);visibility:visible;"]);
  }, function (_ref3) {
    var theme = _ref3.theme;
    return theme.colors.gray;
  }, function (_ref4) {
    var theme = _ref4.theme;
    return _themes.device.desktop(_templateObject || (_templateObject = (0, _taggedTemplateLiteralLoose2.default)(["\n    border: 1px solid ", ";\n    border-radius: 4px;\n    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.3);\n    display: inline-flex;\n    flex-direction: column;\n    height: auto;\n    min-width: 200px;\n    padding: 16px 16px 24px;\n    padding: 16px;\n    position: absolute;\n    right: -18px;\n    text-align: left;\n    top: 110%;\n    transition: visibility 0.8s linear, opacity 0.6s ", ",\n      transform 0.2s ", ";\n\n  \n    li {\n      padding-bottom: 0;\n\n      &:last-of-type {\n        border-bottom: 0;\n        padding-bottom: 0;\n      }\n\n      + li {\n        margin-top: 8px;\n      }\n    }\n\n    &::before {\n      border: 9px solid transparent;\n      border-bottom-color: ", ";\n      content: '';\n      position: absolute;\n      right: 16px;\n      top: -18px;\n    }\n  "])), theme.colors.lightGray, function (_ref5) {
      var theme = _ref5.theme;
      return theme.easing.ease;
    }, function (_ref6) {
      var theme = _ref6.theme;
      return theme.easing.ease;
    }, theme.colors.white);
  });

  _exports.DropdownBox = DropdownBox;
});